import { AbstractControl } from '@angular/forms';

export function passwordValidator(control: AbstractControl): any {

    if (control.value !== null || control.value !== undefined) {
        const cnfpassValue = control.value;

        const passControl = control.root.get('password');
        if (passControl) {
            const passValue = passControl.value;
            if (passValue !== cnfpassValue) {
                return {
                    isError: true
                };
            }
        }
    }
    return null;
}
